import { Box } from '@mui/material';

export const CSSD = () => {
    return <Box sx={{ flex: 1 }}></Box>;
};
